import { FETCH_AGENT_ANALYTIC_REQUESTED, FETCH_AGENT_ANALYTIC_FAILURE, FETCH_AGENT_ANALYTIC_SUCCESS } from "../actions/agent-analytics-action-types";

const initialState = {
  fetchAgentAnalyticsStatus: "pending",
  analytics: {},
};

export default function quotes(state = initialState, {
  payload, type,
}) {
  switch (type) {
    case FETCH_AGENT_ANALYTIC_REQUESTED:
      return {
        ...state,
        fetchAgentAnalyticsStatus: "requested",
        analytics: {},
      };
    case FETCH_AGENT_ANALYTIC_FAILURE:
      return {
        ...state,
        fetchAgentAnalyticsStatus: "failure",
      };
    case FETCH_AGENT_ANALYTIC_SUCCESS:
      return {
        ...state,
        fetchAgentAnalyticsStatus: "success",
        analytics: payload,
      };
    default:
      return state;
  }
}
